export class OverlayToken {
    public id: string;
    public cancelled: boolean;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.id = json.id;
        }
        this.cancelled = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/overlayToken.ts